import { translate } from '@util/Localization';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { PaddedAccentContainer } from '../../styles/ColoredContainers';
import { BodyXS, Heading5 } from '../../styles/Typography';

export const MoneyBackGuarantee: FunctionComponent = () => {
  const guaranteeCopy = `payment.guarantee`;
  return (
    <MoneyBackGuaranteeContainer>
      <Heading5 data-test="moneyBackGuaranteeTitle">
        {translate(`${guaranteeCopy}.control.title`)}
      </Heading5>
      <Body data-test="moneyBackGuaranteeInfo">
        {translate(`${guaranteeCopy}.aiPersonalizedInfo.info`)}
      </Body>
    </MoneyBackGuaranteeContainer>
  );
};

const Body = styled(BodyXS)`
  margin-bottom: 0;
  white-space: pre-line;
`;

const MoneyBackGuaranteeContainer = styled(PaddedAccentContainer)`
  margin-top: ${({ theme }) => theme.spacing._14px};
  border-radius: 12px;
`;
